import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiAward } = FiIcons;

const SIDE_IMG = "https://images.unsplash.com/photo-1534398079543-7ae6d016b86a?auto=format&fit=crop&q=80";

export default function FounderPreview() {
  return (
    <section className="py-24 bg-slate-900 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-900/30 border border-blue-500/30 rounded-sm text-blue-400 text-xs font-bold uppercase tracking-widest mb-6">
              <FiAward className="text-sm" /> Veteran-Owned Business
            </div>
            
            <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-6">
              Veteran-Owned.<br />
              Mission-Driven.<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">Detail-Obsessed.</span>
            </h2>
            
            <p className="text-slate-300 text-lg mb-6 leading-relaxed">
              After 21 years of serving in the United States Navy, Arturio Robertson built A.R.'s Elite Detailing around the same principles that guided his military career—discipline, integrity, precision, and an unwavering commitment to excellence.
            </p>
            
            <p className="text-slate-400 text-base mb-10 leading-relaxed font-medium">
              Every vehicle receives the same attention to detail that defined over two decades of military service.
            </p>
            
            <Link 
              to="/about" 
              className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-blue-600 text-white font-bold rounded-sm hover:bg-blue-500 transition-all uppercase tracking-wide text-sm shadow-[0_4px_24px_rgba(37,99,235,0.3)] hover:-translate-y-0.5"
            >
              Meet the Founder <FiArrowRight />
            </Link>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/5] bg-slate-950 border border-slate-800 p-2 transform rotate-1">
              <img 
                src={SIDE_IMG} 
                alt="A.R.'s Elite Detailing Founder" 
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" 
              />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-blue-600 p-6 md:p-8 shadow-2xl hidden sm:block">
              <div className="text-white font-black uppercase text-xl md:text-2xl leading-tight">
                Military<br />Precision
              </div>
              <div className="w-12 h-1 bg-blue-400 mt-4" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}